import React from 'react'
import imgGeoJSON from './images/file-geojson.png'
import imgKML from './images/file-KML.png'
import imgGPX from './images/file-pgx.png'
import imgTopoJSON from './images/file-TopoJSON.png'

class DragAndDropOption extends React.Component {
  render () {
    return (
      <div className='content-load-layers other-layers'>

        <p className='text-small'> Para cargar ficheros locales, selecciónalos y arrástralos sobre el mapa. Los tipos permitidos son:</p>

        <div className='content-load--images'>
          <img src={imgGeoJSON} alt='GeoJSON' />
          <img src={imgKML} alt='KML' />
          <img src={imgGPX} alt='GPX' />
          <img src={imgTopoJSON} alt='TopoJSON' />
        </div>
        <p className='text-xs'>*Los datos deben estar en el sistema de referencia EPSG:4326 ó EPSG:3857</p>
      </div>
    )
  }
}

export default DragAndDropOption
